import type { Rule } from 'antd/lib/form';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { toIsoDateString } from 'src/shared/utils';
import { validBoarderBirthDate } from 'src/shared/validatorUtils';

export const boarderBirthDateRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct birth date'),
    validator: (_, value: Dayjs) => (
      !value || validBoarderBirthDate(toIsoDateString(value.toDate()))
        ? Promise.resolve()
        : Promise.reject()
    ),
  });
};
